var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('train-menu-layout',[_c('train-workers',{attrs:{"workers":_vm.workers}}),(_vm.model_type)?_c('train-model',{attrs:{"model_type":_vm.model_type}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }